export function getRouteSlugs<T extends Record<string, string>>(root: string, map: T) {
  const slugMap: Record<string, string> = {}

  Object.entries(map).forEach(([k, v]) => {
    slugMap[k] = v.replace(root, '')
  })

  return slugMap as T
}
